module.exports = __webpack_public_path__ + "media/images/mobility/results_arrow-0d759c6bb0f767a1e0ab194f8ff3413d.svg";